import React from 'react';
import { Card, Input, DatePicker, Button, Space } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';

interface FilterPanelProps {
  empFrom: string;
  empTo: string;
  dateFrom: Dayjs | null;
  dateTo: Dayjs | null;
  gradeFrom: string;
  gradeTo: string;
  empFromName: string;
  empToName: string;
  loading: boolean;
  onEmpFromChange: (v: string) => void;
  onEmpToChange: (v: string) => void;
  onDateFromChange: (v: Dayjs | null) => void;
  onDateToChange: (v: Dayjs | null) => void;
  onGradeFromChange: (v: string) => void;
  onGradeToChange: (v: string) => void;
  onEmpFromBlur: () => void;
  onEmpToBlur: () => void;
  onQuery: () => void;
  onReset: () => void;
}

const FilterPanel: React.FC<FilterPanelProps> = React.memo(({
  empFrom, empTo, dateFrom, dateTo, gradeFrom, gradeTo,
  empFromName, empToName, loading,
  onEmpFromChange, onEmpToChange, onDateFromChange, onDateToChange,
  onGradeFromChange, onGradeToChange, onEmpFromBlur, onEmpToBlur,
  onQuery, onReset,
}) => {
  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Space wrap size="middle" align="end">
        {/* Employee Code Range */}
        <div>
          <label className="p9310-filter-label">員工代號 [從]</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Input
              value={empFrom}
              onChange={e => onEmpFromChange(e.target.value)}
              onBlur={onEmpFromBlur}
              placeholder="起始代號"
              style={{ width: 120 }}
              allowClear
            />
            {empFromName && <span className="p9310-lookup-name">{empFromName}</span>}
          </div>
        </div>
        <div>
          <label className="p9310-filter-label">[至]</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Input
              value={empTo}
              onChange={e => onEmpToChange(e.target.value)}
              onBlur={onEmpToBlur}
              placeholder="結束代號"
              style={{ width: 120 }}
              allowClear
            />
            {empToName && <span className="p9310-lookup-name">{empToName}</span>}
          </div>
        </div>

        {/* Date Range */}
        <div>
          <label className="p9310-filter-label">出勤日期 [從]</label>
          <DatePicker
            value={dateFrom}
            onChange={onDateFromChange}
            placeholder="起始日期"
            style={{ width: 140 }}
            allowClear
          />
        </div>
        <div>
          <label className="p9310-filter-label">[至]</label>
          <DatePicker
            value={dateTo}
            onChange={onDateToChange}
            placeholder="結束日期"
            style={{ width: 140 }}
            allowClear
          />
        </div>

        {/* Grade Range */}
        <div>
          <label className="p9310-filter-label">職等 [從]</label>
          <Input
            value={gradeFrom}
            onChange={e => onGradeFromChange(e.target.value)}
            placeholder="起始職等"
            style={{ width: 80 }}
            allowClear
          />
        </div>
        <div>
          <label className="p9310-filter-label">[至]</label>
          <Input
            value={gradeTo}
            onChange={e => onGradeToChange(e.target.value)}
            placeholder="結束職等"
            style={{ width: 80 }}
            allowClear
          />
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', alignItems: 'flex-end', paddingTop: 18 }}>
          <Space>
            <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>
              查詢
            </Button>
            <Button icon={<ClearOutlined />} onClick={onReset}>
              清除
            </Button>
          </Space>
        </div>
      </Space>
    </Card>
  );
});

FilterPanel.displayName = 'FilterPanel';

export default FilterPanel;
